const isObject = (value) => value && typeof value === 'object';

const calculateMetricsForSubreddits = (subreddits) => {
  if (!Array.isArray(subreddits) || subreddits.length === 0) {
    return null;
  }

  const validSubreddits = subreddits.filter(isObject);
  if (validSubreddits.length === 0) {
    return null;
  }

  const totalAudience = validSubreddits.reduce((sum, subreddit) => {
    const subscribers = Number(subreddit.subscribers);
    return Number.isFinite(subscribers) ? sum + subscribers : sum;
  }, 0);
  const totalGrowth = validSubreddits.reduce((sum, subreddit) => {
    const growth = Number(
      subreddit.subscribersMonthlyChange?.percentageChange
    );
    return Number.isFinite(growth) ? sum + growth : sum;
  }, 0);
  const averageGrowth = totalGrowth / validSubreddits.length;

  return {
    totalAudience,
    growthPercentage: parseFloat(Math.abs(averageGrowth.toFixed(1))),
    isIncrease: averageGrowth >= 0,
  };
};

export const calculateAudienceMetrics = (audienceData) => {
  if (!isObject(audienceData) || Array.isArray(audienceData)) {
    return {};
  }

  return Object.entries(audienceData).reduce(
    (results, [audience, subreddits]) => {
      const metrics = calculateMetricsForSubreddits(subreddits);
      if (metrics) {
        results[audience] = metrics;
      }
      return results;
    },
    {}
  );
};
